import { IsEnum } from 'class-validator';

import { UserWatchOptionEnum } from '../../../shared/modules/users/enums/user-watch-option.enum';

export class CreateUserWatchPreferenceDto {
	@IsEnum(UserWatchOptionEnum)
	option!: UserWatchOptionEnum;
}
